import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { articles, ctaFor, isExternal } from "../../../content/articles";
import "./articles.css";

/* Copy and covers live in content/articles.js, shared with the career centre
   page and /insights. The card is the career centre one — cover, category,
   title, read time, link — so a piece looks the same wherever it appears. */
const featured = articles.slice(0, 3);

const Articles = () => (
  <section className="home-articles">
    <div className="home-container">
      <h2 className="home-section-title">
        Reports and thinking from{" "}
        <br className="br-wide" />
        the team behind RAIN
      </h2>

      <div className="home-articles-grid">
        {featured.map((article) => {
          const { slug, tone, cover, title, readTime, url } = article;
          const body = (
            <>
              <span className={`home-article-cover home-article-${tone}`} aria-hidden="true">
                <img decoding="async" src={cover} alt="" loading="lazy" />
              </span>

              <span className="home-article-heading">{title}</span>
              <span className="home-article-read">{readTime}</span>

              <span className="home-article-link">
                {ctaFor(article)}
                <span className="home-article-arrow" aria-hidden="true">
                  <ArrowRight size={12} strokeWidth={2.5} />
                </span>
              </span>
            </>
          );
          /* The tone tints the cover plate only — on the card it would sit
             behind the copy too. */
          const className = "home-article-card";

          return isExternal(url) ? (
            <a key={slug} href={url} className={className} target="_blank" rel="noopener noreferrer">
              {body}
            </a>
          ) : (
            <Link key={slug} to={url} className={className}>
              {body}
            </Link>
          );
        })}
      </div>

      <Link className="home-articles-all" to="/insights">
        See all insights
        <ArrowRight size={16} strokeWidth={2} />
      </Link>
    </div>
  </section>
);

export default Articles;
